export default __webpack_public_path__ + "static/media/location.ef2c2164.svg";